
import React from 'react';
import content from '../data/content';
import '../styles/OtherActivities.css';

function OtherActivities() {
  const { events } = content;

  return (
    <section id="other-activities" className="other-activities-section">
      <div className="other-activities-container">
        <h2>{events.title}</h2>
        <div className="other-activities-grid">
          {events.items.map((item, index) => (
            <div key={index} className="other-activities-card">
              <div className="other-activities-content">
                <h3 className="other-activities-title">{item.title}</h3>
                <p className="other-activities-description">{item.description}</p>
              </div>
              <img src={item.image} alt={item.title} className="other-activities-image" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OtherActivities;
